import React, { useState } from 'react';
import { Grid, GridItem, TextButton, Typography, useGlobalContext } from 'seagull';
import { useResponsive } from "../contexts";
import styles from "./AgreementHeader.module.scss";
import cn from 'classnames';
import { useStore, useStoreActions } from "../../store/store-context";
import { SwitchProposalBusiness } from "../clientOb/WelcomeStep/SwitchProposalBusiness/SwitchProposalBusiness";
import { useSwitchBusiness } from "../../hooks/useSwitchBusiness";
import { routes } from "../../constants";
import { useOnMount } from "../../hooks/useOnMount";
function getFullName(name) {
  return !name.firstName ? null : !name.lastName ? name.firstName : name.firstName + ' ' + name.lastName;
}
export function AgreementHeader(_ref) {
  let {
    relationship,
    companyName,
    className,
    isPreview
  } = _ref;
  const {
    isMobile
  } = useResponsive();
  const {
    logBI
  } = useStoreActions();
  const email = useStore(state => {
    var _state$userInfo;
    return (_state$userInfo = state.userInfo) === null || _state$userInfo === void 0 ? void 0 : _state$userInfo.email;
  });
  const workspaces = useStore(state => {
    var _state$userInfo2;
    return (_state$userInfo2 = state.userInfo) === null || _state$userInfo2 === void 0 ? void 0 : _state$userInfo2.workspaces;
  });
  const globalContext = useGlobalContext();
  const [showSwitchProposalBusiness, setShowSwitchProposalBusiness] = useState(false);
  const switchBusiness = useSwitchBusiness();
  useOnMount(() => {
    if (!isPreview && !relationship.isSample && workspaces) {
      const clientHasMultipleClientBusinesses = (workspaces === null || workspaces === void 0 ? void 0 : workspaces.filter(ws => ws.features.accountsPayable).length) > 1;
      setShowSwitchProposalBusiness(clientHasMultipleClientBusinesses);
    }
  });
  const onSwitchProposalBusiness = async () => {
    logBI(10834, {
      companyName,
      email
    });
    const newBusinessId = await globalContext.showModal({
      content: _ref2 => {
        let {
          dismissModal
        } = _ref2;
        return /*#__PURE__*/React.createElement(SwitchProposalBusiness, {
          onClose: dismissModal,
          relationshipId: relationship.id
        });
      }
    });
    if (newBusinessId) {
      await switchBusiness(newBusinessId, {
        newRoute: routes.clientOnboarding(relationship.id)
      });
    }
  };
  return /*#__PURE__*/React.createElement(Grid, {
    rowGap: 'small',
    className: className
  }, /*#__PURE__*/React.createElement(GridItem, {
    span: 12
  }, /*#__PURE__*/React.createElement(Typography, null, "Agreement between")), /*#__PURE__*/React.createElement(GridItem, {
    span: isMobile ? 12 : 6,
    className: cn(styles.side, {
      [styles.mobile]: isMobile
    })
  }, relationship.seller.firstName && /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary",
    variant: "paragraph1",
    weight: "normal",
    "data-testid": "agreement-header-vendor-name"
  }, getFullName(relationship.seller)), /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary",
    variant: "paragraph1",
    "data-testid": "agreement-header-vendor-business"
  }, relationship.vendor.name)), /*#__PURE__*/React.createElement(GridItem, {
    span: isMobile ? 12 : 6,
    className: cn(styles.side, {
      [styles.mobile]: isMobile
    })
  }, relationship.buyer.firstName && /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary",
    variant: "paragraph1",
    weight: "normal",
    "data-testid": "agreement-header-client-name"
  }, getFullName(relationship.buyer)), /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary",
    variant: "paragraph1",
    "data-testid": "agreement-header-client-business"
  }, companyName), showSwitchProposalBusiness && /*#__PURE__*/React.createElement(TextButton, {
    "data-testid": "switch-proposal-business",
    onClick: onSwitchProposalBusiness
  }, "Assign to a different business")));
}